module.exports = __webpack_public_path__ + "static/media/shutterstock.2a675442.svg";